import styled from 'styled-components'

type SelfServiceTheme = {
  selfServiceFontColor?: string
  selfServiceFontSize?: number
  FontColor?: string
}

const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/

const instructionColor = ({
  selfServiceFontColor,
  FontColor,
}: SelfServiceTheme) => {
  const color = selfServiceFontColor?.trim()
  return color && HEX.test(color) ? color : FontColor || '#434343'
}

const instructionSize = ({ selfServiceFontSize }: SelfServiceTheme) => {
  const size = Number(selfServiceFontSize)
  return Number.isFinite(size)
    ? `${Math.min(40, Math.max(10, Math.round(size)))}px`
    : '12px'
}

export const InstructionsBlock = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    width: 210px;
    color: ${({ theme }) => instructionColor(theme)};
    font-size: ${({ theme }) => instructionSize(theme)};
    margin-bottom: 8px;
  }
`
